import {
  GetStaticPaths,
  GetStaticProps,
  GetStaticPropsContext,
  GetStaticPropsResult,
} from 'next';
import { fetchBySiteMap } from 'src/api/siteMap/dataSiteMap';
import Const from 'src/config/Const';
import Footer from 'src/components/Common/Footer';
import Head, { Metadata } from 'src/components/Common/CommonHead/CommonHead';
import SiteMap from 'src/components/AudioBooksSiteMap/Layout';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { Audio } from 'src/api/siteMap/siteMap.graphql';

type SiteMapProps = {
  siteMapQueryData: Audio[];
  slug: string;
  messages: {
    [index: string]: string;
  };
};

const getMetadata = (letter: string): Metadata => {
  const metadata = {
    title: `Beek - Catálogo de audiolibros letra ${letter.toUpperCase()}`,
    author: 'Beek',
    orgAuthor: 'Beek',
    description:
      'Escucha y aprende de los mejores audiolibros de negocios, cultura, y salud para tu desarrollo personal y profesional.',
    date: '2020-03-02',
    category: 'Audiobooks',
    cover: `${Const.imageCdnUrl}/image/landing_page/beek-meta-image.webp?width=1200&height=630&quality=75&format=jpg`,
    url: `https://beek.io`,
    tags: 'Beek',
  };

  return metadata;
};

const IndexPage = (props: SiteMapProps): JSX.Element => {
  const { siteMapQueryData, slug } = props;
  const metaData = getMetadata(slug);
  const siteMapFiltered = siteMapQueryData.filter(
    (audio) => !audio?.beekTeExplica
  );

  return (
    <>
      <Head metadata={metaData} />
      <SiteMap siteMapQueryData={siteMapFiltered} slug={slug} />
      <Footer />
    </>
  );
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => ({
  paths: [], // return array paths or empty to indicate that no page needs be created at build time
  fallback: 'blocking', // indicates the type of fallback
});

const getFilter = (slug: string): string => {
  const first = slug.split('.');
  const second = first[0].split('_');
  return second[1];
};

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<SiteMapProps>> => {
  const siteMapSlug = context.params?.slug as string;
  let filterSlug = getFilter(siteMapSlug);
  if (!filterSlug) {
    filterSlug = '#';
  }
  const data: Audio[] = await fetchBySiteMap(filterSlug);
  if (!data) {
    return {
      redirect: {
        destination: '/listas',
        statusCode: 301,
      },
    };
  }

  return {
    props: {
      siteMapQueryData: data,
      slug: filterSlug,
      messages: {
        ...require(`src/messages/article/${context.locale}.json`),
      },
    },
  };
};

export default IndexPage;
